import { IconButton } from "@mui/material";
import { HoverPopper } from "../../common/components/functional/hoverPopper/HoverPopper";
import { TalentPopperContent } from "./TalentPopperContent";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useAppDispatch } from "../../app/hooks";
import { fetchTalentPreview } from "./talentsSlice";
import { isFulfilled } from "@reduxjs/toolkit";
import { useCallback, useState } from "react";
import { TalentPreview } from "./talentAPI";

type Props = {
  talentId: string;
};

export const TalentPreviewPopper = ({ talentId }: Props) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);

  const [talentPreviews, setTalentPreviews] = useState<TalentPreview[]>([]);
  const talentPreview = talentPreviews.find((p) => p.talentId === talentId);

  const fetchPreview = useCallback(() => {
    const exists = talentPreviews.some((p) => p.talentId === talentId);
    if (exists) return;
    dispatch(fetchTalentPreview({ talentId }))
      .then((action) => {
        if (isFulfilled(action)) {
          const preview = action.payload as TalentPreview;
          setTalentPreviews((prevPreviews) => [...prevPreviews, preview]);
        }
      })
      .finally(() => setIsLoading(false));
  }, [dispatch, talentId, talentPreviews]);

  return (
    <HoverPopper
      placement="top-start"
      fetchData={fetchPreview}
      trigger={
        <IconButton
          size="small"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      }
    >
      <TalentPopperContent
        talentPreview={talentPreview}
        talentId={talentId}
        isLoading={isLoading}
      />
    </HoverPopper>
  );
};
